import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SaleOverviewPageTourConfig: AgTechTourConfig = {
    id: 'sale-overview-page-tour',
    name: 'Overview Tour',
    steps: [
        {
            targetId: 'sale-overview-lot-grid',
            title: 'Lot Grid',
            description: 'This grid shows all lots in the current sale. You can search, sort columns, and click a row to view or edit lot details.',
            position: 'right',
        },
        {
            targetId: 'sale-overview-registered-bidders',
            title: 'Registered Bidders',
            description: 'The total number of bidders registered for this sale.',
            position: 'left',
        },
        {
            targetId: 'sale-overview-lots-in-sale',
            title: 'Lots In Sale',
            description: 'The total number of lots entered in this sale.',
            position: 'left',
        },
        {
            targetId: 'sale-overview-lots-sold',
            title: 'Lots Sold',
            description: 'Lots that have been sold with a winning bidder and purchase price recorded.',
            position: 'left',
        },
        {
            targetId: 'sale-overview-manage-lots',
            title: 'Manage Lots',
            description: 'Open the lot management panel to view all lots, make bulk updates, and access the selling and update views.',
            position: 'left',
        },
    ]
}
